<template>
  <section class="underwriting-refer">
    <div class="table">
      <div class="tr">
        <span>From Hong Kong to</span>
        <span>{{ getAllOptionName22('from_hk_to', quoteForm.destination_id) }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import { mapState } from 'vuex'
import MixinOptions from '@/mixins/options'
export default {
  name: 'UnderwritingRefer',
  mixins: [MixinOptions],
  computed: {
    ...mapState('quote', ['quoteForm']),
    localAllOptions() {
      return this.allOptions22
    },
  }
}
</script>